module.exports = __webpack_public_path__ + "static/media/health-practitioner-2.ec6235a5.svg";